import React, { Fragment, useEffect, useState } from 'react';
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { Accordion, AccordionBody, Input, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { formikCreateApplication } from './Constant';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../components/InputFields/TextInput';
import { failed, success } from '../../utils/Tostify';
import { createApplication, createApplicationActivity, getApplicationById } from '../../api/Applications';
import Loader from '../../components/Loader/Loader';
import { decryptData } from '../../utils/helper';
import { getAllworkflow } from '../../api/workflow';
import { getPatients } from '../../api/patient';
import { decryptPatientData } from '../../utils/common';
import MultiSelect from '../../components/InputFields/MultiSelect';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router';
import { ActivityDetails } from '../../utils/constants';
import { useGetStates } from '../../hooks/useGetStates';

function StartApplication() {
  let token = useSelector(state => state.userReducer.token);
  const dispatch  = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedWorkflow, setSelectedWorkflow] = useState({});
  const [open, setOpen] = useState('1');
  const [statesList, setStateList] = useState([]);
  const [workflowList, setWorkflowList] = useState([]);
  const [workflowData, setWorkflowData] = useState([]);
  const [formsToBeSigned, setFormsToBeSigned] = useState([]);
  const [patients, setPatients] = useState([]);
  const [activeTab, setActiveTab] = useState('2');
  const location = useLocation();
  const patientData = location?.state?.patientDetails;
  const [patientList, setPatientList] = useState([]);
  let user = useSelector((state) => state.userReducer.user);
  const { states } = useGetStates("US");
  const applicationList = location.state?.applicationList || [];
  const currentOrgId = localStorage.getItem("currentOrgId");

  useEffect(() => {
      if (states && states.length > 0) {
          const formattedStates = states.map((obj) => ({
              label: obj.name,
              value: obj.name
          }));
          setStateList(formattedStates);
      }
  }, [states]);

  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const formik = useFormik({
    ...formikCreateApplication,
    onSubmit: async (values) => {
        let res;
        try {
            handleNext(values);
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    }
  });
  const handleSubmit = async(values) =>{
    try {
      values.eligibilityCriteria =  {
        stateOfResidence : values?.stateOfResidence,
        age : values?.age,
        householdIncome : values?.householdIncome,
        eligiblityGroup : values?.eligiblityGroup
      };
      values.stages = selectedWorkflow?.applicationType?.applicationStages;
      values.consultantId = user?._id;
      values.clinicId = localStorage.getItem("currentHospitalId");
      // values.uploadedBy = user._id;
      setIsLoading(true);
      let response = await createApplication({ values, dispatch, token ,currentOrgId});
      const responseData = response?.data && decryptData(response?.data);
      if (response?.code === 200) {
          let values = {
            type : "Application",
            event : ActivityDetails?.NotesAdded?.event,
            applicationId : responseData?._id,
            clinicId: localStorage.getItem("currentHospitalId"),
            organizationId: localStorage.getItem("currentOrgId"),
            patientId : responseData?.patientId,
            details : ActivityDetails?.ApplicationStarted?.details
          };
          await createApplicationActivity({ values, dispatch, token });
          const res = await getApplicationById({ dispatch, token, applicationId: responseData?._id });
          const aplnData = decryptData(res?.data);
          setIsLoading(false);
          success(response?.message);
          formik.resetForm();
          navigate("/app/application-detail", { state: { applicationData: aplnData } });
        }else{
          setIsLoading(false);
          failed(response?.message);
      }} catch (error) {
          setIsLoading(false);
          failed("Something went wrong. Please try again.");
  }
  };
  const handleBack = ()=>{
      switch (activeTab) {
          case "2": setActiveTab("1");
          break;
          case "3": setActiveTab("2");
          break;
          case "4": setActiveTab("3");
          break;
          case "5": setActiveTab("4");
          break;
          case "6": setActiveTab("5");
          break;
          default: return null; // Or a default component if necessary
      }
  };
  const handleNext = () => {
    if(isLoading) return;
    switch (activeTab) {
        case "2":
            if ((formik.values.patientId === null)) {
                if (formik.values.patientId === null) {
                    formik.setFieldError("patientId", "Required Field");
                    return false; // Prevent navigation to the next tab
                }
              }
            setActiveTab("3");
            getWorkflowList();
            break;
        case "3":
          if ((formik.values.workflowId === "") || (formik.values.title === "")) {
                if (formik.values.workflowId === "") {
                    formik.setFieldError("workflowId", "Required Field");
                }
                if (formik.values.title === "") {
                  formik.setFieldError("title", "Required Field");
                }
                return false;
            }
            setActiveTab("4");
            break;
        case "4":
            if (formik.values.pdfFormIds?.length === 0) {
                formik.setFieldError("pdfFormIds", "Required Field");
                return false;
            }
            setActiveTab("5");
            break;
        case "5":
            if (formik.values.documents?.length === 0) {
                formik.setFieldError("documentId", "Required Field");
                return false;
            }
            handleSubmit(formik.values); // Submit the form when all conditions are met
            break;
        default: return null;
    }
  };

  const handleStates =(e)=>{
    formik.setFieldValue("stateId", e.target.value);
    formik.setFieldValue("stateOfResidence", statesList?.find((obj)=> obj?.value === e.target.value));
  };

  useEffect(() => {
    if (patientData?._id) {
    formik.setFieldValue(
      "patientId", patientData?._id
   );
  }},[patientData]);

  const getPatientList = async () => {
  let res;
  try {
    setIsLoading(true);
    res = await getPatients({
      dispatch,
      token,
      orgId: localStorage.getItem("currentOrgId"),
      clinicId: localStorage.getItem("currentHospitalId")
    });

    if (res?.status === "SUCCESS") {
      const responseData = decryptData(res?.data);

      if (responseData?.list) {
        const decryptedPatients = await Promise.all(
          responseData?.list?.map(async (patient) => {
            return decryptPatientData(patient);
          })
        );

        setPatientList(decryptedPatients);

        // Step 1: Extract patientIds from applicationList where status is "InProcess"
        const inProcessPatientIds = applicationList?.allApplicationsList?.filter(app => app.status === "InProcess" && app.patientId).map(app => app.patientId.toString());

        // Step 2: Filter patients excluding those in inProcessPatientIds
        const filteredPatients = decryptedPatients
          .filter(
            (obj) =>
              obj?.staffId &&
              obj?.system_ai_care === "Yes" &&
              obj?.archieve === false &&
              !inProcessPatientIds?.includes(obj._id.toString()) // filter out
          )
          .map((obj) => ({
            value: obj?._id,
            label: obj?.name?.text
          }));

        setPatients(filteredPatients);
      }
      setIsLoading(false);
    }
  } catch (error) {
    failed(res?.message);
    setIsLoading(false);
  }
};

  const getWorkflowList = async (page, limit, searchKey = "") => {
    let res;
    try {
        setIsLoading(true);
        // setSearch(searchKey);
        res = await getAllworkflow({dispatch, token, page, limit, searchKey, dataLimit: "all"});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            setWorkflowData(responseData?.items);
            // Ensure that patientState is correctly retrieved
            const patientState = patientList.find(patient => patient._id === formik.values.patientId)?.address?.state;
            const workflowStateWise = responseData?.items
                .filter((workflow) => workflow.state.label === patientState && workflow.isPublished === true)
                .map((obj) => ({
                    value: obj._id,
                    label: obj.workflowTitle
                }));
            // Update the workflow list state
            setWorkflowList(workflowStateWise.length > 0 ? workflowStateWise : []);
            setIsLoading(false);
        } else {
            setIsLoading(false);
            failed(res?.message);
        }
    } catch (error) {
        setIsLoading(false);
        failed(error.message);  // Use the error object to get the message
    }
};

 const handleAge = (event) => {
    let key = event.key;
    let regex = new RegExp("^[0-9]+$");
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };

  const handlePdfForms = (e)=>{
    const { value, checked } = e.target;
    if (checked) {
      formik.setFieldValue('pdfFormIds', [...formik.values.pdfFormIds, value]);
      setFormsToBeSigned([...formsToBeSigned, selectedWorkflow.pdfFormData.find((obj)=> obj?._id === value)]);
    } else {
      formik.setFieldValue('pdfFormIds', formik.values.pdfFormIds.filter((item) => item !== value));
      setFormsToBeSigned(formsToBeSigned.filter((item) => item?._id !== value));
    }
  };

  useEffect(() => {
    if (selectedWorkflow?.pdfFormData?.length > 0) {
      const allFormIds = selectedWorkflow.pdfFormData.map(f => f._id);
      formik.setFieldValue('pdfFormIds', allFormIds);
      setFormsToBeSigned(selectedWorkflow.pdfFormData);
    }
  }, [selectedWorkflow]);

  const handleDocumentType = (e)=>{
    const { value, checked } = e.target;
    if (checked) {
      formik.setFieldValue('documents', [...formik.values.documents, {documentId : value}]);
    } else {
      formik.setFieldValue('documents', formik.values.documents?.filter((item) => item?.documentId !== value));
    }
  };

  useEffect(() => {
    if (selectedWorkflow?.documentType?.length > 0) {
      const allDocuments = selectedWorkflow.documentType.map(doc => ({ documentId: doc._id }));
      formik.setFieldValue('documents', allDocuments);
    }
  }, [selectedWorkflow]);


  useEffect(() => {
    getPatientList();
  }, []);

  const calculateAge = (dob) => {
    if (!dob) return '';
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  return (
    <Fragment>
      {isLoading ? <Loader/> : null}
      <Form onSubmit={formik.handleSubmit}>
        <div className='start_application_block'>
          <div className='d-flex align-items-center justify-content-between start_application_block_header flex-wrap gap-3'>

           <h2>
            Start Application {patientData?.name?.text && `- ${patientData.name.text}`}
            </h2>
            <div className="tab_responsive overflow-x-scroll overflow-y-hidden whitespace-nowrap m-0">
              <Nav tabs className="profile_intab flex-nowrap d-flex nav nav-tabs gap-2 border-0">
                <NavItem className="inline-block">
                  <NavLink className={(activeTab === '2' || activeTab === '3' || activeTab === '4' || activeTab === '5' || activeTab === '6') ? 'active' : ''}> Start</NavLink>
                </NavItem>
                <NavItem className="inline-block">
                  <NavLink className={(activeTab === '2' || activeTab === '3' || activeTab === '4' || activeTab === '5' || activeTab === '6') ? 'active' : ''}>Applicant</NavLink>
                </NavItem>
                <NavItem className="inline-block">
                  <NavLink className={(activeTab === '3' || activeTab === '4' || activeTab === '5' || activeTab === '6') ? 'active' : ''}>Workflow Type</NavLink>
                </NavItem>
                <NavItem className="inline-block">
                  <NavLink className={(activeTab === '4' || activeTab === '5' || activeTab === '6') ? 'active' : ''}>PDF Form</NavLink>
                </NavItem>
                <NavItem className="inline-block">
                  <NavLink className={(activeTab === '5' || activeTab === '6') ? 'active' : ''}>Documents</NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
          <div className="tab-top">
            <div>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="2">
                  <Accordion open={open} toggle={toggle}>
                    <AccordionBody accordionId="1">
                      <Row>
                          <Col lg={4} className="location_block">
                          {/* <label className="form-label">Primary Applicant</label> */}
                          {patients?.length ? (
                            <MultiSelect
                              keyField={"patientId"}
                              formik={formik}
                              multiple={false}
                              label="Primary Applicant"
                              disabled={patientData?._id}
                              options={patients}
                              type="select"
                              value={formik.values.patientId}
                              onChange={(e) => formik.setFieldValue("patientId", e)}
                            />
                          ) : (
                            <div className="no-patients-msg" style={{ color: "#999", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", background: "#f8f9fa" }}>
                              No Patients Available
                            </div>
                          )}
                        </Col>
                        <Col lg={4} className="location_block">
                          <TextInput
                              keyField={"stateId"}
                              formik={formik}
                              required={false}
                              multiple={false}
                              label="State"
                              options={states.map((obj) => {
                                return {
                                    label: obj.name,
                                    value: obj.name
                                };
                              })}
                              type="select"
                              value={patientList.find(patient => patient._id == formik.values.patientId)?.address?.state}
                              onChange={handleStates}
                              readOnly
                          />
                        </Col>
                      </Row>
                      <Row>
                      <Col lg={4} className="location_block">
                          <TextInput
                              keyField={"age"}
                              formik={formik}
                              required={false}
                              label="Age"
                              type="text"
                              value={calculateAge(patientList.find(patient => patient._id == formik.values.patientId)?.birthDate)}
                              onChange={(e) => formik.setFieldValue("age", Number(e.target.value))}
                              onKeyPress={handleAge}
                              readOnly
                          />
                        </Col>
                        <Col lg={4} className="location_block">
                          <TextInput
                              keyField={"householdIncome"}
                              formik={formik}
                              required={false}
                              label="Household Income"
                              type="text"
                              value={patientList.find(patient => patient._id == formik.values.patientId)?.houseHoldIncome}
                              onKeyPress={handleAge}
                              onChange={(e) => formik.setFieldValue("householdIncome", Number(e.target.value))}
                              readOnly
                          />
                        </Col>
                        {/* <Col lg={4} className="location_block mb-3">
                          <p>Medicaid Eligibility Group</p>
                           {(Array.isArray(patientList.find(patient => patient._id == formik.values.patientId)?.medicaidElegibitlyGroup))
                            ? patientList.find(patient => patient._id == formik.values.patientId).medicaidElegibitlyGroup.join(", ")
                            : " "}
                        </Col> */}
                        <Col lg={4} className="location_block mb-3">
                          <TextInput
                            keyField={"medicaidElegibitlyGroup"}
                            formik={formik}
                            required={false}
                            label="Medicaid Eligibility Group"
                            type="text"
                            value={
                              Array.isArray(patientList.find(patient => patient._id == formik.values.patientId)?.medicaidElegibitlyGroup)
                                ? patientList.find(patient => patient._id == formik.values.patientId).medicaidElegibitlyGroup.join(", ")
                                : ""
                            }
                            readOnly
                          />
                        </Col>
                      </Row>
                    </AccordionBody>
                  </Accordion>
                </TabPane>
              <TabPane tabId="3">
                  <Accordion open={open} toggle={toggle}>
                    <AccordionBody accordionId="1">
                      <Row>
                      <Col lg={4} className="location_block">
                        <TextInput
                            keyField={"title"}
                            formik={formik}
                            label="Application Title"
                            type="text"
                            value={formik.values.title}
                            onChange={(e) => formik.setFieldValue("title", e.target.value)}
                        />
                        </Col>
                        <Col lg={3} className="location_block">
                          <TextInput
                            keyField={"workflowId"}
                            formik={formik}
                            label="Workflow Type"
                            options={workflowList}
                            type="select"
                            value={formik.values.workflowId}
                            onChange={(e) => {
                              formik.setFieldValue("workflowId", e.target.value);
                              formik.setFieldValue("applicationType", {
                                _id: workflowData?.find((obj) => obj?._id === e.target.value)?.applicationType?._id,
                                applicationTitle: workflowData?.find((obj) => obj?._id === e.target.value)?.applicationType?.applicationTitle
                              });
                              setSelectedWorkflow(workflowData?.find((obj)=> obj?._id === e.target.value));
                            }}
                          />
                        </Col>
                      </Row>
                    </AccordionBody>
                  </Accordion>
                </TabPane>
                <TabPane tabId="4">
                <Accordion open={open} toggle={toggle}>
                    <AccordionBody accordionId="1" className="form_tab mt-3">
                        <Label>PDF Forms</Label>
                        <table>
                            <thead>
                                <tr className="header_table">
                                    <th>Select</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            {selectedWorkflow.pdfFormData?.length > 0 && selectedWorkflow?.pdfFormData?.map((form,index)=> (
                              <tbody key={form?._id}>
                                  <tr>
                                      <td colSpan={8} className="bg_light"></td>
                                  </tr>
                                  <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                                      <td>
                                          <FormGroup check className="custom-checkbox">
                                              <Input type="checkbox" id={form?._id}  value={form?._id} onChange={handlePdfForms} checked={formik.values.pdfFormIds.includes(form?._id)}
                                              />
                                          </FormGroup>
                                      </td>
                                      <td>{form?.formTitle}</td>
                                  </tr>
                              </tbody>
                             ))}
                        </table>
                        {formik?.touched["pdfFormIds"] && formik?.errors["pdfFormIds"] ? <span style={{color : "red"}}>{formik?.errors["pdfFormIds"]}</span> : ""}
                    </AccordionBody>
                </Accordion>
                </TabPane>
                <TabPane tabId="5">
                <Accordion open={open} toggle={toggle}>
                    <AccordionBody accordionId="1" className="form_tab mt-3">
                        <Label>Document Required as a proof</Label>
                          <table>
                              <thead>
                                  <tr className="header_table">
                                      <th>Select</th>
                                      <th>Name</th>
                                  </tr>
                              </thead>
                              {selectedWorkflow?.documentType?.length > 0 && selectedWorkflow?.documentType?.map((doc)=> (
                                <tbody key={doc?._id}>
                                    <tr>
                                        <td colSpan={8} className="bg_light"></td>
                                    </tr>
                                    <tr className="first_block">
                                        <td>
                                            <FormGroup check className="custom-checkbox">
                                                <Input type="checkbox" id={doc?._id}  value={doc?._id} onChange={handleDocumentType} checked={formik.values.documents?.some(item => item.documentId === doc?._id)}
                                                />
                                            </FormGroup>
                                        </td>
                                        <td>{doc?.name}</td>
                                    </tr>
                                </tbody>
                              ))}
                          </table>
                          {formik?.touched["documentId"] && formik?.errors["documentId"] ? <span style={{color : "red"}}>{formik?.errors["documentId"]}</span> : ""}
                    </AccordionBody>
                  </Accordion>
                </TabPane>
              </TabContent>
            </div>
          </div>
          <div className='d-flex justify-content-between align-items-end butttons'>
                <button
                    className="save_btn saving"
                    type="button"
                    style={{
                        backgroundColor: activeTab == "2" ? "#8F8F8F" : null, // Replace #primaryColor with your desired color when enabled
                        cursor: activeTab == "2" ? "not-allowed" : "pointer", // Optional: change cursor when disabled
                        color: activeTab == "2" ? "#ffffff" : null // Optional: change text color when disabled
                      }}
                      disabled={activeTab == "2"}
                      onClick={handleBack}
                > Back</button>
                <div className="d-flex gap-3 justify-content-end mt-5 button_blkj flex-wrap">
                    <button className="save_btn cancel_btn" type="button"  onClick={()=> navigate(-1)}>Cancel</button>
                    <button className="save_btn" type="submit">{activeTab == "5" ? "Save" : "Next"}</button>
                </div>
          </div>
        </div>
      </Form>
    </Fragment>
  );
}

export default StartApplication;
